import { EcCountry } from './country';
import { Horaire } from './horaire';
import { EbEtablissement } from './etablissement';
import { EbAdresse } from './adresse';
export class EbParty {

    ebPartyNum: number;
    company: String;
    adresse: String;
    city: String;
    zipCode: String;
    xEcCountry: EcCountry;
    openingHours: Horaire;
    airport: String;
    email: String;
    phone: String;
    etablissement: EbEtablissement;
    commentaire: String;
    reference: String;
    efsServices: String;
    heureEnlevement: string;
    xEbAdresse: EbAdresse;

    constructor() {
        this.ebPartyNum = null;
        this.company = null;
        this.city = null;
        this.airport = null;
        this.xEcCountry = null;
        this.zipCode = null;
        this.adresse = null;
        this.openingHours = null;
        this.email = null;
        this.phone = null;
        this.etablissement = null;
        this.commentaire = null;
        this.reference = null;
        this.efsServices = null;
        this.heureEnlevement = null;
        this.xEbAdresse = null;
    }

    constructorCopy(ebParty: EbParty) {
        this.ebPartyNum = ebParty.ebPartyNum;
        this.company = ebParty.company;
        this.city = ebParty.city;
        this.phone = ebParty.phone;
        this.airport = ebParty.airport;
        if (ebParty.xEcCountry !== null) {
            this.xEcCountry = new EcCountry();
            this.xEcCountry.constructorCopy(ebParty.xEcCountry);
        }
        else {
            this.xEcCountry = null;
        }
        this.zipCode = ebParty.zipCode;
        this.email = ebParty.email;
        this.openingHours = ebParty.openingHours;
        this.commentaire = ebParty.commentaire;
        this.reference = ebParty.reference;
        this.efsServices = ebParty.efsServices;
        this.heureEnlevement = ebParty.heureEnlevement;
        this.xEbAdresse = ebParty.xEbAdresse;
        this.adresse = ebParty.adresse;
    }
   static copyPartyJustId(ebParty: EbParty):EbParty{
        let paty:EbParty=new EbParty();
        paty.ebPartyNum = ebParty.ebPartyNum;
        paty.company = ebParty.company;
        paty.city = ebParty.city;
        paty.phone = ebParty.phone;
        paty.airport = ebParty.airport;
        if (ebParty.xEcCountry !== null) {
            paty.xEcCountry = new EcCountry();
            paty.xEcCountry.ecCountryNum=ebParty.xEcCountry.ecCountryNum;
        }
        else {
            paty.xEcCountry = null;
        }
        paty.zipCode = ebParty.zipCode;
        paty.email = ebParty.email;
        paty.openingHours = ebParty.openingHours;
        paty.commentaire = ebParty.commentaire;
        paty.reference = ebParty.reference;
        paty.efsServices = ebParty.efsServices;
        paty.heureEnlevement = ebParty.heureEnlevement;
        paty.xEbAdresse=new EbAdresse()
        paty.xEbAdresse.ebAdresseNum = ebParty.xEbAdresse.ebAdresseNum;
        paty.adresse = ebParty.adresse;
        return paty;
    }
}




// WEBPACK FOOTER //
// ./src/app/classes/party.ts